import {
    GET_KEY_STAGES_SUCCESS,
    GET_KEY_STAGES_FAILED
} from './actionTypes'

const INIT_STATE = {
    keystages: [],
    error: "",
    form_errors: []
}

const KeyStageReducer = (state = INIT_STATE, { type, payload }) => {
    
    switch (type) {
        
        case GET_KEY_STAGES_SUCCESS: {
            return {
                ...state,
                keystages: payload
            }
        }

        case GET_KEY_STAGES_FAILED: {
            return {
                ...state,
                error: payload
            }
        }
        default:
            return state
    }
}

export default KeyStageReducer